import React, { createContext, useContext, useEffect, useMemo } from "react";
import { isProd } from "../lib/utils";
import { useToast } from "../hooks/use-toast";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
	const {toast} = useToast();
	useEffect(() => {
		if(isProd){
			const handleKeyPress = (event) => {
				if (event.key === 'F12' || (event.ctrlKey && event.shiftKey && event.key === 'I')) {
					event.preventDefault();
					toast({
						title: 'Action Blocked',
						description: 'Opening developer tools is disabled in production.',
						status: 'warning',
						duration: 3000,
						isClosable: true,
					});
				}
			};
			window.addEventListener('keydown', handleKeyPress);
			return () => window.removeEventListener('keydown', handleKeyPress);
		}
	}, []);

	

	return <SettingsContext.Provider value={{}}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => {
	const ctx = useContext(SettingsContext);
	if (!ctx) {
		throw new Error("useSettings must be used within a SettingsProvider");
	}
	return ctx;
};